import { render } from "./PersonalGoalEdit.vue?vue&type=template&id=6b9ee0df&ts=true"
import script from "./PersonalGoalEdit.vue?vue&type=script&lang=ts"
export * from "./PersonalGoalEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__